<template>
    <span class="svgItem">
        <svg
            v-if="icon === 'profile'"
            :height="computedSize"
            viewBox="0 0 24 24"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>

        <svg
            v-else-if="icon === 'addPhoto'"
            :height="computedSize"
            viewBox="0 0 24 24"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <path d="M24 24H0V0h24v24z" id="a" />
            </defs>
            <clipPath id="b">
                <use overflow="visible" xlink:href="#a" />
            </clipPath>
            <path
                clip-path="url(#b)"
                d="M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"
            />
        </svg>

        <svg
            v-else-if="icon === 'home'"
            :height="computedSize"
            viewBox="0 0 24 24"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>

        <svg
            v-else-if="icon === 'message'"
            :height="computedSize"
            viewBox="0 0 24 24"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>

        <svg
            v-else-if="icon === 'bell'"
            :height="computedSize"
            viewBox="0 0 24 24"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
            />
        </svg>

        <svg
            v-else-if="icon === 'contact'"
            :height="computedSize"
            viewBox="0 0 24 24"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>

        <svg
            v-else-if="icon === 'thumbDown'"
            :height="computedSize"
            viewBox="0 0 24 24"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
                d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"
            />
        </svg>

        <svg
            v-else-if="icon === 'thumbUp'"
            :height="computedSize"
            viewBox="0 0 24 24"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
                d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z"
            />
        </svg>

        <svg
            v-else-if="icon === 'add'"
            :height="computedSize"
            viewBox="0 0 24 24"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>
        <svg
            v-else-if="icon === 'no-animals'"
            :height="computedSize"
            viewBox="0 0 512 512"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m406.023438 259.089844c5.542968-11.085938 18-18.535156 30.992187-18.535156 41.347656 0 74.984375-33.636719 74.984375-74.984376v-41.726562l-125.648438-31.152344-41.835937-83.671875-57.304687 143.265625c-6.875 17.179688-23.269532 28.28125-41.773438 28.28125h-43.15625l-180.570312-180.566406-21.207032 21.207031 159.359375 159.359375h-77.046875l-82.816406-92.875 23.773438 153.230469c4.304687 26.898437.75 55.679687-10.269532 83.238281-8.886718 22.214844-13.394531 45.613282-13.394531 69.539063v86.804687h54.261719l47.550781-95.105468c7.4375-14.875 24.011719-24.871094 41.242187-24.871094h75.816407c17.152343 0 32.570312 9.53125 40.242187 24.871094l47.550782 95.105468h51.96875l14.4375-86.621094 117.222656 117.21875 21.207031-21.207031-132.371094-132.371093 5.488281-32.941407c3.800782-22.792969 10.964844-44.824219 21.296876-65.492187zm-72.691407 191.417968h-8.019531l-39.265625-78.523437c-12.78125-25.566406-38.480469-41.449219-67.066406-41.449219h-75.820313c-28.757812 0-55.476562 16.269532-68.066406 41.449219l-39.261719 78.523437h-5.726562v-56.808593c0-20.09375 3.78125-39.742188 11.246093-58.398438 13.035157-32.589843 17.199219-66.867187 12.050782-99.046875l-8.191406-52.792968 24.160156 27.101562h120.484375l157.257812 157.253906zm-101.058593-239.945312h13.160156c30.839844 0 58.167968-18.503906 69.621094-47.136719l32.503906-81.253906 18.148437 36.300781 116.300781 28.835938v18.261718c0 24.808594-20.183593 44.992188-44.992187 44.992188-24.460937 0-47.15625 13.785156-57.820313 35.117188-11.671874 23.339843-19.761718 48.226562-24.054687 73.96875l-1.96875 11.8125zm0 0"
            />
        </svg>
        <svg
            v-else-if="icon === 'no-smoking'"
            :height="computedSize"
            viewBox="0 0 512 512"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m422.9375 90.605469h-34.507812c-6.191407-17.460938-22.871094-30-42.429688-30h-90c-24.8125 0-45 20.1875-45 45s20.1875 45 45 45h30.3125c14.082031 18.695312 36.234375 30 59.6875 30h91c19.554688 0 36.226562 12.542969 42.421875 30h-247.207031l-210.609375-210.605469-21.210938 21.210938 189.390625 189.394531h-189.785156v120h309.785156l180.609375 180.605469 21.210938-21.210938-159.390625-159.394531h159.785156v-150.9375c0-49.109375-39.953125-89.0625-89.0625-89.0625zm-392.9375 150h121v60h-121zm151 60v-60h38.785156l60 60zm81.214844-60h159.785156v60h-99.785156zm219.785156 60h-30v-60h30zm-45-150h-91c-16.023438 0-30.496094-8.425781-38.714844-22.542969l-4.335937-7.457031h-46.949219c-8.269531 0-15-6.726563-15-15 0-8.269531 6.730469-15 15-15h90c8.269531 0 15 6.730469 15 15v15h61.9375c27.195312 0 50.15625 18.472656 56.992188 43.53125-12.171876-8.523438-26.976563-13.53125-42.929688-13.53125zm0 0"
            />
        </svg>
        <svg
            v-else-if="icon === 'no-kids'"
            :height="computedSize"
            :width="computedSize"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M256,0C114.833,0,0,114.844,0,256s114.833,256,256,256s256-114.844,256-256S397.167,0,256,0z M256,490.667 C126.604,490.667,21.333,385.396,21.333,256c0-60.874,23.495-116.225,61.642-157.971l115.302,115.305h-48.923v-32 c0-5.896-4.771-10.667-10.667-10.667h-21.333c-5.896,0-10.667,4.771-10.667,10.667c0,5.896,4.771,10.667,10.667,10.667h10.667v32 c0,51.465,28.247,96.376,69.991,120.303c-15.943,6.186-27.324,21.59-27.324,39.697c0,23.531,19.146,42.667,42.667,42.667 c23.521,0,42.667-19.135,42.667-42.667c0-8.289-2.475-15.97-6.582-22.523c5.664,0.707,11.396,1.19,17.249,1.19 s11.585-0.483,17.249-1.19c-4.107,6.553-6.582,14.234-6.582,22.523c0,23.531,19.146,42.667,42.667,42.667 c23.521,0,42.667-19.135,42.667-42.667c0-2.381-0.327-4.678-0.703-6.954l51.982,51.983 C372.221,467.173,316.871,490.667,256,490.667z M277.354,200.25v-93.104c26.771,2.427,50.979,13.875,69.542,31.292L277.354,200.25 z M361.083,154.375c12.417,16.802,20.479,37.01,22.458,58.958H294.75L361.083,154.375z M383.542,234.667 c-3.161,34.987-22.01,65.266-49.155,84.613l-84.611-84.613H383.542z M341.354,384c0,11.76-9.563,21.333-21.333,21.333 c-11.771,0-21.333-9.573-21.333-21.333c0-11.76,9.563-21.333,21.333-21.333C331.792,362.667,341.354,372.24,341.354,384z  M315.294,330.353c-14.87,6.828-31.203,10.98-48.607,10.98c-61.104,0-111.458-46.948-116.854-106.667h69.777L315.294,330.353z  M234.688,384c0,11.76-9.563,21.333-21.333,21.333c-11.771,0-21.333-9.573-21.333-21.333c0-11.76,9.563-21.333,21.333-21.333 C225.125,362.667,234.688,372.24,234.688,384z M429.049,413.944l-79.227-79.228c33.641-25.327,55.531-65.462,55.531-110.716 c0-76.458-62.208-138.667-138.667-138.667c-5.896,0-10.667,4.771-10.667,10.667v117.333h-27.577L98.061,82.947 C139.805,44.816,195.142,21.333,256,21.333c129.396,0,234.667,105.271,234.667,234.667 C490.667,316.861,467.182,372.202,429.049,413.944z"
            />
        </svg>
        <svg
            v-else-if="icon === 'star'"
            :height="computedSize"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>
        <svg
            v-else-if="icon === 'star-empty'"
            :height="computedSize"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path
                d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>
        <svg
            v-else-if="icon === 'star-half'"
            :height="computedSize"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 24 24"
        >
            <defs><path id="a" d="M0 0h24v24H0V0z" /></defs>
            <clipPath id="b">
                <use xlink:href="#a" overflow="visible" />
            </clipPath>
            <path
                clip-path="url(#b)"
                d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
            />
        </svg>
        <svg
            v-else-if="icon === 'seat'"
            :height="computedSize"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path
                d="M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
            />
            <path fill="none" d="M0 0h24v24H0z" />
        </svg>
        <svg
            v-else-if="icon === 'circle'"
            :height="computedSize"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path fill="none" d="M24 24H0V0h24v24z" />
            <circle fill="#010101" cx="12" cy="12" r="8" />
        </svg>
        <svg
            v-else-if="icon === 'pets'"
            :height="computedSize"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <circle cx="4.5" cy="9.5" r="2.5" />
            <circle cx="9" cy="5.5" r="2.5" />
            <circle cx="15" cy="5.5" r="2.5" />
            <circle cx="19.5" cy="9.5" r="2.5" />
            <path
                d="M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
            />
            <path fill="none" d="M0 0h24v24H0z" />
        </svg>
        <svg
            v-else-if="icon === 'smoking'"
            :height="computedSize"
            :width="computedSize"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path
                d="M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z"
            />
            <path fill="none" d="M0 0h24v24H0z" />
        </svg>
        <svg
            v-else-if="icon === 'kids'"
            :height="computedSize"
            :width="computedSize"
            viewBox="-1 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m508.015625 112.144531c-2.628906-5.59375-7.28125-9.832031-13.101563-11.925781-5.816406-2.097656-12.097656-1.804688-17.695312.828125l-47.164062 22.179687c-9.175782 4.3125-14.203126 13.917969-13.160157 23.472657l-20.289062 9.542969c-9.792969 4.605468-16.125 14.574218-16.125 25.398437v7.054687h-118.265625c-4.144532 0-7.5 3.359376-7.5 7.5 0 4.144532 3.355468 7.5 7.5 7.5 0 0 125.519531.011719 125.625.015626 2.796875.1875 5.015625 2.523437 5.015625 5.367187v1.859375c0 3.125-2.59375 5.195312-5.542969 5.382812h-158.914062c4.003906-5.703124 6.355468-12.644531 6.355468-20.125 0-7.40625-2.304687-14.28125-6.234375-19.953124l105.335938-112.886719c2.828125-3.03125 2.664062-7.777344-.367188-10.601563-3.027343-2.824218-7.773437-2.660156-10.597656.363282l-2.828125 3.03125c-31.621094-27.226563-71.222656-42.832032-112.933594-44.507813v-4.140625c0-4.144531-3.359375-7.5-7.5-7.5-4.144531 0-7.5 3.355469-7.5 7.5v4.144531c-41.714844 1.671875-81.316406 17.28125-112.9375 44.503907l-2.824218-3.027344c-2.828126-3.03125-7.570313-3.191406-10.601563-.367188-3.027344 2.824219-3.191406 7.570313-.367187 10.601563l2.828124 3.03125c-15.785156 15.953125-28.386718 34.402343-37.503906 54.9375-9.574218 21.570312-14.839844 44.441406-15.6875 68.082031-8.652344 2.355469-15.035156 10.28125-15.035156 19.671875v1.855469c0 8.875 5.699219 16.441406 13.628906 19.234375v67.304687c0 44.160156 35.929688 80.089844 80.089844 80.089844h18.222656l-33.457031 37.007812c-4.367187-1.257812-8.976563-1.933593-13.742187-1.933593-27.394532 0-49.679688 22.289062-49.679688 49.683593 0 27.394532 22.285156 49.679688 49.679688 49.679688 24.847656 0 45.488281-18.332031 49.117187-42.179688h180.136719c3.628906 23.847657 24.269531 42.179688 49.117187 42.179688 27.394531 0 49.679688-22.285156 49.679688-49.679688 0-27.394531-22.285157-49.683593-49.679688-49.683593-3.851562 0-7.597656.441406-11.199219 1.273437l-32.859374-36.347656h16.339843c44.160157 0 80.085938-35.929688 80.085938-80.089844v-6.210937c0-4.144531-3.355469-7.5-7.5-7.5-4.140625 0-7.5 3.355469-7.5 7.5v6.210937c0 35.890625-29.195313 65.089844-65.085938 65.089844h-221.675781c-35.890625 0-65.089844-29.199219-65.089844-65.089844v-66.152344h351.851563v25.175782c0 4.144531 3.359375 7.5 7.5 7.5 4.144531 0 7.5-3.355469 7.5-7.5v-26.816406c7.269531-3.117188 12.375-10.347657 12.375-18.742188v-1.859375c0-8.394531-5.105469-15.625-12.375-18.742187v-8.695313c0-5.039063 2.949219-9.679687 7.507812-11.824219l20.300781-9.546875c4.300782 4.417969 10.285157 7.050781 16.625 7.050781 3.414063 0 6.726563-.742187 9.839844-2.203124l47.164063-22.179688c11.546875-5.429688 16.523437-19.246094 11.097656-30.792969zm-375.855469 265.417969h14.683594l-45.898438 50.769531c-2.488281-2.648437-5.265624-5.027343-8.277343-7.082031zm111.773438 0 55.402344 61.285156c-2.636719 4.890625-4.472657 10.273438-5.339844 15.972656h-180.136719c-.738281-4.847656-2.179687-9.464843-4.210937-13.746093l57.414062-63.511719zm-179.191406 119.4375c-19.125 0-34.679688-15.558594-34.679688-34.679688 0-19.125 15.554688-34.683593 34.679688-34.683593 19.121093 0 34.679687 15.558593 34.679687 34.683593 0 19.121094-15.558594 34.679688-34.679687 34.679688zm313.050781-34.679688c0 19.121094-15.558594 34.679688-34.679688 34.679688-19.503906 0-35.183593-16.96875-34.601562-36.242188.535156-17.820312 16.925781-33.121093 34.601562-33.121093 19.121094 0 34.679688 15.558593 34.679688 34.683593zm-60.625-42.355468c-3.117188 1.917968-6.007813 4.167968-8.621094 6.703125l-44.394531-49.105469h14.679687zm-117.527344-243.878906c11.089844 0 20.113281 9.019531 20.113281 20.109374 0 11.089844-9.023437 20.109376-20.113281 20.109376s-20.109375-9.019532-20.109375-20.109376c0-11.089843 9.023438-20.109374 20.109375-20.109374zm110.179687-108.960938-92.265624 98.882812c-3.1875-1.898437-6.695313-3.308593-10.425782-4.121093v-135.230469c37.898438 1.65625 73.871094 15.832031 102.691406 40.46875zm-117.691406-40.46875v135.238281c-3.726562.816407-7.234375 2.222657-10.417968 4.121094l-92.273438-98.890625c28.820312-24.636719 64.792969-38.8125 102.691406-40.46875zm-147.695312 100.757812c8.292968-18.683593 19.726562-35.488281 34.035156-50.054687l92.285156 98.898437c-3.925781 5.667969-6.222656 12.539063-6.222656 19.9375 0 7.480469 2.351562 14.421876 6.351562 20.125h-150.5c-2.96875 0-5.382812-2.417968-5.382812-5.386718v-1.855469c0-2.96875 2.414062-5.382813 5.382812-5.382813h116.65625c4.144532 0 7.5-3.355468 7.5-7.5 0-4.144531-3.355468-7.5-7.5-7.5h-106.964843c.917969-21.277343 5.734375-41.859374 14.359375-61.28125zm446.101562 1.949219s-47.132812 22.164063-47.164062 22.175781c-4.03125 1.898438-8.945313.097657-10.847656-3.917968-1.898438-4.0625-.144532-8.914063 3.914062-10.824219 0 0 47.136719-22.164063 47.164062-22.175781 3.949219-1.855469 8.941407-.132813 10.839844 3.902344 1.910156 4.066406.15625 8.929687-3.90625 10.839843zm0 0"
            />
            <path
                d="m64.742188 438.191406c-13.304688 0-24.128907 10.824219-24.128907 24.128906 0 13.300782 10.824219 24.125 24.128907 24.125 13.304687 0 24.128906-10.824218 24.128906-24.125 0-13.304687-10.824219-24.128906-24.128906-24.128906zm0 33.253906c-5.03125 0-9.128907-4.09375-9.128907-9.125 0-5.035156 4.097657-9.128906 9.128907-9.128906s9.128906 4.09375 9.128906 9.128906c0 5.03125-4.097656 9.125-9.128906 9.125zm0 0"
            />
            <path
                d="m318.984375 462.320312c0 13.300782 10.824219 24.125 24.128906 24.125 13.300781 0 24.125-10.824218 24.125-24.125 0-13.304687-10.824219-24.128906-24.125-24.128906-13.304687 0-24.128906 10.824219-24.128906 24.128906zm33.257813 0c0 5.03125-4.097657 9.125-9.128907 9.125-5.035156 0-9.128906-4.09375-9.128906-9.125 0-5.035156 4.09375-9.128906 9.128906-9.128906 5.03125 0 9.128907 4.09375 9.128907 9.128906zm0 0"
            />
        </svg>
        <svg
            v-else-if="icon === 'icono-sentado'"
            :width="computedSize"
            :height="computedSize"
            viewBox="0 0 24 24"
        >
            <path
                fill="#0070B8"
                d="M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
            />
            <path fill="none" d="M0 0h24v24H0z" />
        </svg>
        <svg
            v-else-if="icon === 'remove'"
            :width="computedSize"
            :height="computedSize"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path d="M19 13H5v-2h14v2z" />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>
        <svg
            v-else-if="icon === 'candado-abierto'"
            xmlns="http://www.w3.org/2000/svg"
            :width="computedSize"
            :height="computedSize"
            viewBox="0 0 24 24"
        >
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path
                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
            />
        </svg>
        <svg
            v-else-if="icon === 'candado-cerrado'"
            xmlns="http://www.w3.org/2000/svg"
            :width="computedSize"
            :height="computedSize"
            viewBox="0 0 24 24"
        >
            <g fill="none">
                <path d="M0 0h24v24H0V0z" />
                <path opacity=".87" d="M0 0h24v24H0V0z" />
            </g>
            <path
                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
            />
        </svg>
        <svg
            v-else-if="icon === 'world'"
            xmlns="http://www.w3.org/2000/svg"
            :width="computedSize"
            :height="computedSize"
            viewBox="0 0 24 24"
        >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'svgItem',
    data() {
        return {};
    },
    props: ['icon', 'size'],
    computed: {
        computedSize() {
            if (!this.size) {
                return 48;
            } else {
                return this.size;
            }
        }
    }
};
</script>

<style>
svg {
    fill: #000;
}
.profile_image-edit svg {
    fill: var(--secondary-background);
}
.profile_image-edit:hover svg {
    fill: #0f90bb;
}
.trip-detail-component .profile-info--ratings svg {
    display: inline;
    margin-right: 0.4em;
    vertical-align: middle;
    fill: #fff;
}
</style>
